module.exports = __webpack_public_path__ + "static/media/remove_user.e8faa68f.svg";